import { render, staticRenderFns } from "./ChannelMessageModal.vue?vue&type=template&id=63f76eee&"
import script from "./ChannelMessageModal.vue?vue&type=script&lang=js&"
export * from "./ChannelMessageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports